import {observer} from "mobx-react";
import React, {Component} from "react";
import localStyles from "../index.css";
import {Bunker, RailCart, Truck} from "../../SubComponents";
import {scenario} from "../../../../stores";

@observer
export default class ReceptionBunker extends Component{
    render() {
        const item = this.props.item;
        const i = this.props.i;
        let activeTransport = item.activeTransport;
        return(
            <div className={localStyles.bunkerRow} >
                <div className={localStyles.bunkerInline} onClick={()=>{scenario.openPathPopup(!!item.scenario.length ? item.scenario : item, !!item.scenario.length)}}>
                    <Bunker item={item} i={i}/>
                </div>
                <div className={localStyles.truckRailCartHolder}>
                    {
                        item.activeTransport.disabled ? null :
                            item.bunkerType === "train" ?
                                <RailCart item={activeTransport}/>
                                :
                                <Truck item={activeTransport} backwards={true}/>
                    }
                </div>
                <div className={localStyles.nearestQueueThumbs}>
                    {item.getThumbs.map((thumb,i)=>{
                        return(  <QueueThumb culture={thumb.culture} number={thumb.number} key={i} />)
                    })}
                </div>
            </div>
        )
    }
}

const QueueThumb = (props) => {
    return(
        <span className={(props.culture ? ' ' + localStyles[props.culture] : '') + (props.number>1 ? '' : ' ' + localStyles.notGroup)}>{props.number>1 ? props.number : ''}</span>
    )
};


// WEBPACK FOOTER //
// ./src/shared/components/Game/InputFlow/ReceptionBunker/index.js